import { render, staticRenderFns } from "./RightCenter2.vue?vue&type=template&id=0920506c&scoped=true"
import script from "./RightCenter2.vue?vue&type=script&lang=js"
export * from "./RightCenter2.vue?vue&type=script&lang=js"
import style0 from "./RightCenter2.vue?vue&type=style&index=0&id=0920506c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920506c",
  null
  
)

export default component.exports